export default {
    view: "About"
};